// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.update-contract-info .form-group select {\n  padding: 1rem;\n  min-width: 280px;\n  margin-bottom:10px;\n}\n.update-contract-info .input-group {\n  max-width: 600px;\n}\n", ""]);
// Exports
module.exports = exports;
